import { RecursosScreen } from "@/screens/recursos";

/** Thin wrapper — toda lógica fica em screens/recursos */
export function RecursosPage() {
  return <RecursosScreen />;
}
